<ion-app>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
<div class="dev" *ngIf="isDev">DEV BUILD</div>
